export const INIT_AUTH = 'INIT_AUTH' as const;
export const AUTHENTICATE = 'AUTHENTICATE' as const;
export const GET_TOKEN = 'GET_TOKEN' as const;
export const REFRESH_TOKEN = 'REFRESH_TOKEN' as const;
export const RELEASE_REQUEST = 'RELEASE_REQUEST' as const;
export const REVOKE_TOKEN = 'REVOKE_TOKEN' as const;
export const ADD_HEADERS = 'ADD_HEADERS' as const;
export const EVAL_CLAIM = 'EVAL_CLAIM' as const;
export const GET_CLAIM = 'GET_CLAIM' as const;
export const IS_TOKEN_EXPIRED = 'IS_TOKEN_EXPIRED' as const;

export type WorkerActions = 'INIT_AUTH' | 'AUTHENTICATE' | 'GET_TOKEN' | 'REFRESH_TOKEN' | 'RELEASE_REQUEST' | 'REVOKE_TOKEN' | 'ADD_HEADERS' | 'EVAL_CLAIM' | 'GET_CLAIM' | 'IS_TOKEN_EXPIRED';
